module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Db-Gc-Ha-Ia.928ef9a3.png";